export const SDK_VERSION = '2.9.6';